"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestClient = void 0;
var axios_1 = __importDefault(require("axios"));
var constants_1 = require("../../constants");
var APIError_1 = require("./APIError");
var utils_1 = require("./utils");
var RequestClient = /** @class */ (function () {
    function RequestClient(_a) {
        var logger = _a.logger, _b = _a.multipartParser, multipartParser = _b === void 0 ? utils_1.toMultipart : _b, config = __rest(_a, ["logger", "multipartParser"]);
        this.config = config;
        this.logger = logger || constants_1.silentLogger;
        this.axios = axios_1.default.create(config);
        this.applyInterceptors();
        this.queue = {};
        this.toMultipart = multipartParser;
    }
    RequestClient.prototype.applyInterceptors = function () {
        var _this = this;
        this.axios.interceptors.request.use(function (c) { return __awaiter(_this, void 0, void 0, function () {
            var reqConfig, _a, _b, _c, middleware, e_1_1;
            var e_1, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        reqConfig = c;
                        if (!(reqConfig.multipart && this.config.automaticMultipartParsing)) return [3 /*break*/, 2];
                        _a = reqConfig;
                        return [4 /*yield*/, this.toMultipart(reqConfig.data)];
                    case 1:
                        _a.data = _e.sent();
                        reqConfig.headers.set('Content-Type', 'multipart/form-data');
                        _e.label = 2;
                    case 2:
                        if (!this.config.requestMiddleware) return [3 /*break*/, 10];
                        _e.label = 3;
                    case 3:
                        _e.trys.push([3, 8, 9, 10]);
                        _b = __values(this.config.requestMiddleware), _c = _b.next();
                        _e.label = 4;
                    case 4:
                        if (!!_c.done) return [3 /*break*/, 7];
                        middleware = _c.value;
                        return [4 /*yield*/, middleware(reqConfig)];
                    case 5:
                        reqConfig = (_e.sent()) || reqConfig;
                        _e.label = 6;
                    case 6:
                        _c = _b.next();
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _e.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/, reqConfig];
                }
            });
        }); });
    };
    RequestClient.prototype.setInQueue = function (req) {
        var requestId = (0, utils_1.getRequestId)(req, this.config);
        this.queue[requestId] = __assign(__assign({}, this.queue[requestId]), req);
    };
    RequestClient.prototype.setConfig = function (to) {
        this.config = __assign(__assign({}, this.config), to);
        this.axios = axios_1.default.create(this.config);
        this.applyInterceptors();
    };
    RequestClient.prototype.removeFromQueue = function (req) {
        var requestId = (0, utils_1.getRequestId)(req, this.config);
        delete this.queue[requestId];
    };
    RequestClient.prototype.abort = function (reqId) {
        var _a, _b;
        if ((_b = (_a = this.queue) === null || _a === void 0 ? void 0 : _a[reqId]) === null || _b === void 0 ? void 0 : _b.controller) {
            this.queue[reqId].controller.abort();
        }
    };
    RequestClient.prototype.onRequestFailure = function (err, request, reject) {
        var _a = (0, utils_1.parseFailedRequest)(err, request, this.config), failedRequest = _a.failedRequest, shouldReject = _a.shouldReject;
        this.setInQueue(failedRequest);
        var logName = request.errorLogSeverity || 'error';
        var apiError = new APIError_1.APIError(failedRequest.errorReason, request.url, err);
        if (!request.silent) {
            this.logger[logName](apiError, 'Network');
        }
        if (!!this.config.onError) {
            this.config.onError(apiError);
        }
        if (shouldReject) {
            reject(apiError);
        }
    };
    RequestClient.prototype.onRequest = function (data) {
        var _this = this;
        var _a, _b;
        var requestId = "".concat(data.baseURL || ((_a = this.config) === null || _a === void 0 ? void 0 : _a.baseURL) || '').concat(data.url);
        if (((_b = this.queue[requestId]) === null || _b === void 0 ? void 0 : _b.requestStatus) === 'in_progress') {
            switch (data.duplicateBehavior) {
                case 'cancelPrevious':
                    this.abort(requestId);
                    break;
                case 'maintainPrevious':
                    return new Promise(function (res, rej) {
                        rej({ errorReason: 'ALREADY_IN_PROGRESS' });
                    });
            }
        }
        var controller = new AbortController();
        this.setInQueue(__assign(__assign({}, data), { controller: controller, requestStatus: 'in_progress' }));
        var promise = new Promise(function (resolve, reject) {
            _this.axios(__assign(__assign(__assign({}, _this.config), { signal: controller.signal }), data)).then(function (response) {
                _this.setInQueue(__assign(__assign({}, data), { controller: controller, requestStatus: 'successful' }));
                _this.logger.log("".concat(data.method.toUpperCase(), " ").concat(_this.config.baseURL + data.url, " Successful ").concat(response.status), response.data, 'Network');
                resolve(response);
            }).catch(function (err) {
                if (data.debug) {
                    console.log(err === null || err === void 0 ? void 0 : err.request);
                }
                _this.onRequestFailure(err, __assign({}, data), reject);
            });
        });
        promise.abort = function () {
            _this.abort(requestId);
        };
        return promise;
    };
    RequestClient.prototype.patch = function (url, data, config) {
        return this.onRequest(__assign({ url: url, data: data, method: 'PATCH' }, config));
    };
    RequestClient.prototype.put = function (url, data, config) {
        return this.onRequest(__assign({ url: url, data: data, method: 'PUT' }, config));
    };
    RequestClient.prototype.get = function (url, config) {
        return this.onRequest(__assign({ url: url, method: 'GET' }, config));
    };
    RequestClient.prototype.delete = function (url, config) {
        return this.onRequest(__assign({ url: url, method: 'DELETE' }, config));
    };
    RequestClient.prototype.post = function (url, data, config) {
        return this.onRequest(__assign({ url: url, data: data, method: 'POST' }, config));
    };
    RequestClient.prototype.branch = function (branchConfig) {
        var config = __assign(__assign(__assign({}, this.config), branchConfig), { multipartParser: this.toMultipart, logger: this.logger });
        if (!!(branchConfig === null || branchConfig === void 0 ? void 0 : branchConfig.baseURL)) {
            config.baseURL = this.config.baseURL + branchConfig.baseURL;
        }
        return new RequestClient(config);
    };
    return RequestClient;
}());
exports.RequestClient = RequestClient;
